import * as types from '../mutation-types'
import api from '../api'
import Vue from 'vue'

const defaultState = () => ({
    instructions: {},

    defaultForwardingAddress: {},
    futureDefaultForwardingAddress: {},
    activeForwardingAddress: {},
    punctualForwardingAddress: {},
    contractMailOption: {},
    optionsInstructions: [],
    mailWithdrawalProxies: [],
    hotlineContacts: [],
    fullOffers: [],
})

const state = {
    fetching: false,
    id: null,
    model: {},

    ...defaultState()
}

const mutations = {
    [types.FETCHING_SWITCH](state) {
        state.fetching = !state.fetching
    },

    [types.CONTRACT_RECEIVED](state, payload) {
        const contract = payload.contract

        state.id = contract.id
        state.model = _.assign({}, contract)
        state = _.assign({}, state, defaultState())
    },

    [types.RESET_INSTRUCTIONS](state, payload) {
        state.instructions = {}
    },
    
    [types.INSTRUCTIONS_RECEIVED](state, payload) {
        state.instructions = _.assign({}, payload)
    },

    [types.OPTIONS_INSTRUCTIONS_RECEIVED](state, payload) {
        state.optionsInstructions = [].concat(payload)
    },

    [types.DEFAULT_FORWARDING_ADDRESS_RECEIVED](state, payload) {
        // console.log(payload)
        state.defaultForwardingAddress = _.assign({}, payload)
    },

    [types.FUTURE_DEFAULT_FORWARDING_ADDRESS_RECEIVED](state, payload) {
        // console.log(payload)
        state.futureDefaultForwardingAddress = _.assign({}, payload)
    },

    [types.ACTIVE_FORWARDING_ADDRESSES_RECEIVED](state, payload) {
        // console.log(payload)
        state.activeForwardingAddress = _.assign({}, payload)
    },
    [types.PUNCTUALS_FORWARDING_ADDRESSES_RECEIVED](state, payload) {
        // console.log(payload)
        state.punctualForwardingAddress = _.assign({}, payload)
    },

    [types.MAIL_OPTION_DETERMINED](state, payload) {
        state.contractMailOption = _.assign({}, payload)
    },

    [types.MAIL_WITHDRAWAL_PROXIES_RECEIVED](state, payload) {
        Vue.set(state, "mailWithdrawalProxies", payload)
    },

    [types.MAIL_WITHDRAWAL_PROXY_ADDED](state, payload) {
        state.mailWithdrawalProxies.push(payload)
    },

    [types.MAIL_WITHDRAWAL_PROXY_REMOVED](state, payload) {
        state.mailWithdrawalProxies = _.filter(state.mailWithdrawalProxies, (mail_withdrawal_proxy) => mail_withdrawal_proxy.id !== payload.id)
    },

    [types.HOTLINE_CONTACTS_RECEIVED](state, payload) {
        Vue.set(state, "hotlineContacts", payload)
    },

    [types.HOTLINE_CONTACT_ADDED](state, payload) {
        state.hotlineContacts.push(payload)
    },

    [types.HOTLINE_CONTACT_UPDATED](state, payload) {
        const index = _.findIndex(state.hotlineContacts, {id: payload.id})

        state.hotlineContacts.splice(index, 1, payload)
    },
    
    [types.HOTLINE_CONTACT_REMOVED](state, payload) {
        state.hotlineContacts = _.filter(state.hotlineContacts, (contact) => contact.id !== payload.id)
    },

    [types.FULLOFFERS_RECEIVED](state, payload) {
        if (_.find(state.fullOffers, (offer) => offer.id == payload.offer.id) == undefined)
            state.fullOffers.push(payload.offer)
    },

}

const actions = {
    fetchContract({ commit }, id) {
        return api.fetchContract(id)
            .then(response => commit(types.CONTRACT_RECEIVED, response.data))
    },

    fetchInstructions({ commit, state }) {
        commit(types.RESET_INSTRUCTIONS)

        return api.fetchContractInstructions(state.id)
            .then(response => {
                const { form } = response.data

                form.model = _.mapValues(
                    form.model,
                    (field) => _.isBoolean(field) ? Number(field) : field
                )
                commit(types.INSTRUCTIONS_RECEIVED, form)
            })
    },

    updateOptionInstructions({ dispatch, state }, model) {
        // debugger
        return api.updateOptionInstructions(state.id, model.id, model)
            .then(response => dispatch('fetchOptionsInstructions'))
    },

    fetchOptionsInstructions({ commit, state }) {
        const contractOptions = state.model.contract_options
        // debugger
        const promises = _.map(
            contractOptions,
            (contractOption) => api.fetchOptionInstructions(state.id, contractOption.id)
        )

        return Promise.all(promises)
            .then(responsesArray => {
                commit(
                    types.OPTIONS_INSTRUCTIONS_RECEIVED,
                    _.map(responsesArray, 'data.form')
                )
            })
    },

    updateInstructions({ state, dispatch }, model) {
        return api.updateContractInstructions(state.id, model)
            .then(response => dispatch('fetchInstructions'))
    },
    
    cancelContract({ state, dispatch }, contractId) {
        return api.cancelContract(contractId)
            .then(response => {
                dispatch('customer/fetchContracts', {
                    search: "refused:0", 
                    with: "proxies.type;contract_options_all"
                }, { root: true })
            })
    },

    fetchMailWithdrawalProxies({ commit }) {
        return api.getMailWithdrawalProxies(state.id)
            .then(response => commit(types.MAIL_WITHDRAWAL_PROXIES_RECEIVED, response.data.proxies))
    },

    addMailWithdrawalProxy({ commit, state }, model) {
        return api.addMailWithdrawalProxy(state.id, model)
            .then(response => {
                // Datas :
                const newMailWithDrawalProxy = response.data.proxy
                commit(types.MAIL_WITHDRAWAL_PROXY_ADDED, newMailWithDrawalProxy)
            })
    },

    removeMailWithdrawalProxy({ commit, state }, model) {
        return api.removeMailWithdrawalProxy(state.id, model.id)
            .then(response => commit(types.MAIL_WITHDRAWAL_PROXY_REMOVED, model))
    },

    fetchForwardingAddresses({ commit, state }) {
        const contractOptions = state.model.contract_options

        if (_.isNil(contractOptions)
            || contractOptions.length < 0)
            return;

        commit(types.MAIL_OPTION_DETERMINED, {})

        let contractMailOption = _.find(
            contractOptions,
            contractOption => contractOption.option.mail_kept || contractOption.option.mail_forwarded
        ),
            isMailForwarded = contractMailOption.option.mail_forwarded

        commit(types.MAIL_OPTION_DETERMINED, contractMailOption)

        if (!isMailForwarded)
            return Promise.resolve(false)

        return Promise.all([
            api.getActiveMailForwardingAddress(state.id, contractMailOption.id),
            api.getDefaultMailForwardingAddress(state.id, contractMailOption.id),
            api.getFutureDefaultMailForwardingAddress(state.id, contractMailOption.id),
            api.getAllMailForwardingAddresses(state.id, contractMailOption.id)
        ]).then(responses => {


            const addresses = _.map(responses, (response) => response.data.hasOwnProperty("address") ?
                response.data.address : response.data.addresses),
                activeAddress = addresses[0],
                defaultAddress = addresses[1],
                futureDefaultAddress = addresses[2],
                punctuals = _.filter(addresses[3], (address) => !address.mail_forward_default)

            commit(types.ACTIVE_FORWARDING_ADDRESSES_RECEIVED, activeAddress)
            commit(types.DEFAULT_FORWARDING_ADDRESS_RECEIVED, defaultAddress)
            commit(types.FUTURE_DEFAULT_FORWARDING_ADDRESS_RECEIVED, futureDefaultAddress)
            commit(types.PUNCTUALS_FORWARDING_ADDRESSES_RECEIVED, punctuals)

        })

    },

    fetchHotlineContacts({ getters, commit }) {
        const simpleHotlineContractOption = getters.simpleHotlineContractOption
        
        if (!simpleHotlineContractOption)
            return

        return api.fetchHotlineContacts(state.id, simpleHotlineContractOption.id)
            .then(response => commit(types.HOTLINE_CONTACTS_RECEIVED, response.data.hotline_contacts))
    },

    addHotlineContact({ getters, commit, state }, model) {
        const simpleHotlineContractOption = getters.simpleHotlineContractOption
        
        if (!simpleHotlineContractOption)
            return

        return api.addHotlineContact(state.id, simpleHotlineContractOption.id, model)
                .then(response => {
                    // Datas :
                    const newContact = response.data.hotline_contact
                    commit(types.HOTLINE_CONTACT_ADDED, newContact)
                })
    },

    updateHotlineContact({ getters, commit, state }, model) {
        const simpleHotlineContractOption = getters.simpleHotlineContractOption
        
        if (!simpleHotlineContractOption)
            return

        return api.updateHotlineContact(state.id, simpleHotlineContractOption.id, model.hotline_contact.id, model)
                .then(response => commit(types.HOTLINE_CONTACT_UPDATED, model.hotline_contact))
    },

    removeHotlineContact({ getters, commit, state }, model) {
        const simpleHotlineContractOption = getters.simpleHotlineContractOption
        
        if (!simpleHotlineContractOption)
            return

        return api.removeHotlineContact(state.id, simpleHotlineContractOption.id, model.id)
            .then(response => commit(types.HOTLINE_CONTACT_REMOVED, model))
    },

    fetchSingleFullOffer({ commit }, offer_id) {
        return api.fetchOfferById(offer_id)
            .then((response) => commit(types.FULLOFFERS_RECEIVED, response.data))
    },

}

const getters = {
    anyPunctualAdresses(state) {
        return !_.isEmpty(state.punctualForwardingAddress)
    },

    anyForwardingAddresses(state) {
        return !_.isEmpty(state.activeForwardingAddress)
    },

    anyFutureDefaultAddress(state) {
        return !_.isEmpty(state.futureDefaultForwardingAddress)
    },

    canEditDefaultAddress(state) {
        return _.isEmpty(state.futureDefaultForwardingAddress)
    },

    canEditFutureDefaultAddress(state, getters) {
        return !getters.canEditDefaultAddress
    },

    simpleHotlineContractOption(state, getters) {
        const contractOptions = state.model.contract_options
        
        if (_.isNil(contractOptions) || contractOptions.length <= 0)
            return null
        
        const simpleHotlineContractOption = _.filter(contractOptions, co => co.option.simple_hotline == true 
            && _.includes(['active', 'pending-termination'], co.status))[0]
        
        return undefined == simpleHotlineContractOption ? null : simpleHotlineContractOption
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}



// WEBPACK FOOTER //
// ./client/store/modules/contract.js